import {Document, Line, Page, Svg, Text, View} from "@react-pdf/renderer";
import {styles} from "./ModelAPdf";

export function ModelBPdf(props) {
    const {modelBTempObject} = props;
    return <Document>
        <Page size="A4" style={styles.page}>
            <View style={styles.section}>
                <Text style={styles.title}>Model B Inschrijvingsformulier 'club'</Text>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Provincie: </Text>
                            <Text style={styles.fieldText}>{modelBTempObject.provincie}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Sector: </Text>
                            <Text style={styles.fieldText}>{modelBTempObject.sector}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Club: </Text>
                            <Text style={styles.fieldText}>{modelBTempObject.club}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Stamnr: </Text>
                            <Text style={styles.fieldText}>{modelBTempObject.stamnr}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gesticht in: </Text>
                            <Text style={styles.fieldText}>{modelBTempObject.gestichtin}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Vzw: </Text>
                            <Text style={styles.fieldText}>{modelBTempObject.vzw}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Vzw: </Text>
                            <Text style={styles.fieldText}>{modelBTempObject.ondernemingsNummer}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Naam schutterslokaal: </Text>
                            <Text style={styles.fieldText}>{modelBTempObject.naamSchuttersLokaal}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Adres: </Text>
                            <Text style={styles.fieldText}>{modelBTempObject.adres}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Telefoon: </Text>
                            <Text style={styles.fieldText}>{modelBTempObject.telefoon}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gsm: </Text>
                            <Text style={styles.fieldText}>{modelBTempObject.gsm}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Fax: </Text>
                            <Text style={styles.fieldText}>{modelBTempObject.fax}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <Text style={styles.smallestTile}>Voorzitter</Text>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Naam, Voornaam: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.naamVoornaamVoorzitter}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Straat, Nr: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.straatNrVoorzitter}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Postnr, Gemeente: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.postnrVoorzitter}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Tel/Gsm/Email: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.telgsmemailVoorzitter}</Text>
                    </View>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>

                <Text style={styles.smallestTile}>Secretaris</Text>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Naam, Voornaam: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.naamVoornaamSecretaris}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Straat, Nr: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.straatNrSecretaris}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Postnr, Gemeente: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.postnrSecretaris}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Tel/Gsm/Email: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.telgsmemailSecretaris}</Text>
                    </View>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>

                <Text style={styles.smallestTile}>Penningsmeester</Text>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Naam, Voornaam: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.naamVoornaamPenningsmeester}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Straat, Nr: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.straatNrPenningsmeester}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Postnr, Gemeente: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.postnrPenningsmeester}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Tel/Gsm/Email: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.telgsmemailPenningsmeester}</Text>
                    </View>
                </View>
            </View>


        </Page>
        <Page size="A4" style={styles.page}>
            <View style={styles.section}>
                <Text style={styles.title}>Raadsleden</Text>

                <Text style={styles.smallestTile}>Raadslid 1</Text>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Naam, Voornaam: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.naamVoornaamCommisaris1}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Straat, Nr: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.straatNrCommisaris1}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Postnr, Gemeente: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.postnrCommisaris1}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Tel/Gsm/Email: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.telgsmemailCommisaris1}</Text>
                    </View>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <Text style={styles.smallestTile}>Raadslid 2</Text>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Naam, Voornaam: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.naamVoornaamCommisaris2}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Straat, Nr: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.straatNrCommisaris2}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Postnr, Gemeente: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.postnrCommisaris2}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Tel/Gsm/Email: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.telgsmemailCommisaris2}</Text>
                    </View>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <Text style={styles.smallestTile}>Raadslid 3</Text>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Naam, Voornaam: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.naamVoornaamCommisaris3}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Straat, Nr: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.straatNrCommisaris3}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Postnr, Gemeente: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.postnrCommisaris3}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Tel/Gsm/Email: </Text>
                        <Text style={styles.fieldText}>{modelBTempObject.telgsmemailCommisaris3}</Text>
                    </View>
                </View>
            </View>
        </Page>
    </Document>
}